import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Injects JSON-LD structured data into the document head.
 */
const JsonLd = ({ data }) => {
  if (!data) return null;

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default JsonLd;
